import { useState } from "react";
import { Container, Row, Col, Modal, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  BsBoxArrowUpRight,
  BsCodeSlash,
  BsPalette,
  BsGrid,
  BsInstagram,
  BsX,
} from "react-icons/bs";
import gd1 from "../../assets/1.png";
import gd2 from "../../assets/2.jpg";
import gd3 from "../../assets/3.jpg";
import gd4 from "../../assets/4.jpg";
import gd7 from "../../assets/7.jpg";
import gd11 from "../../assets/11.png";
import imgLogosDesign from "../../assets/logos-design.jpeg";
import imgMallika from "../../assets/Mallika.jpeg";
import imgHoof from "../../assets/Hoof.jpeg";
import imgExtraw from "../../assets/Extraw.jpeg";
import imgSkin from "../../assets/Skin.jpeg";
import imgMadras from "../../assets/Madras MCPL.jpeg";
import imgBuildcare from "../../assets/Buildcare.jpeg";
import imgSparkle from "../../assets/Sparkle.jpeg";
import imgAdorable from "../../assets/Adorable.jpeg";
import imgTharun from "../../assets/Tharun.jpeg";
import imgBNI from "../../assets/BNI.jpeg";
import imgVishwaksenaa from "../../assets/Vishwaksenaa.jpeg";
import "./projects.css";

const projects = [
  // E-commerce
  {
    id: 2,
    title: "Mallika Shopping",
    category: "ecommerce",
    link: "https://mallikaonline.in/",
    image: imgMallika,
    tags: ["E-commerce", "Furniture & Electronics"],
    desc: "Full-featured online shopping platform with seamless checkout and product management.",
  },
  {
    id: 3,
    title: "Hoof & Arrow",
    category: "ecommerce",
    link: "https://hoofandarrow.netlify.app/",
    image: imgHoof,
    tags: ["E-commerce", "Bags"],
    desc: "Modern e-commerce store with custom theme and optimized conversion flow.",
  },
  // Business Websites
  {
    id: 1,
    title: "Extraw Designs",
    category: "Business",
    link: "https://extrawdesigns.com/",
    image: imgExtraw,
    tags: ["Business", "Interior Design"],
    desc: "Creative design studio e-commerce platform with portfolio and shop integration.",
  },
  {
    id: 4,
    title: "Skin Health Centre",
    category: "Business",
    link: "https://skinhealthcentre.in/",
    image: imgSkin,
    tags: ["Business", "Healthcare"],
    desc: "Professional healthcare website for a skin clinic with appointment booking.",
  },
  {
    id: 5,
    title: "Madras MCPL",
    category: "Business",
    link: "https://madrasmcpl.com/",
    image: imgMadras,
    tags: ["Business", "Construction"],
    desc: "Corporate business website with service showcase and lead generation.",
  },
  {
    id: 6,
    title: "Buildcare Associates",
    category: "Business",
    link: "https://buildcareassociates.com/",
    image: imgBuildcare,
    tags: ["Business", "Construction"],
    desc: "Construction and building services company website with project portfolio.",
  },
  {
    id: 7,
    title: "Sparkle Consulting",
    category: "Business",
    link: "https://sparkleconsulting.in/",
    image: imgSparkle,
    tags: ["Business", "HR Agency"],
    desc: "Business consulting firm website with service pages and client testimonials.",
  },
  {
    id: 8,
    title: "Zime AI",
    category: "Business",
    link: "https://zime.ai/",
    image:
      "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&h=600&fit=crop",
    tags: ["Business", "AI", "SaaS"],
    desc: "AI-powered business intelligence platform for data-driven decision making.",
  },
  // Landing Pages
  {
    id: 9,
    title: "Ekattor8",
    category: "landing",
    link: "https://adorable-jalebi-e9d2de.netlify.app/",
    image: imgAdorable,
    tags: ["Landing Page", "Education"],
    desc: "Vibrant landing page for a food brand with strong visual identity.",
  },
  // Software
  // {
  //   id: 13,
  //   title: "HRMs Software",
  //   category: "software",
  //   link: "https://firewings.in/",
  //   image:
  //     "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
  //   tags: ["Software", "HR"],
  //   desc: "Enterprise HR management system with payroll, attendance, and reporting modules.",
  // },
  // {
  //   id: 14,
  //   title: "Billing Software",
  //   category: "software",
  //   link: "https://quadverge-billingsoftware.netlify.app/",
  //   image:
  //     "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=600&fit=crop",
  //   tags: ["Software", "Billing"],
  //   desc: "Intuitive billing and invoicing software for small and medium businesses.",
  // },
  // Social Media
  {
    id: 15,
    title: "Extraw Designs",
    category: "social",
    link: "https://www.instagram.com/extrawdesigns9/",
    image:
      imgExtraw,
    tags: ["Social Media", " Interior Design"],
    desc: "Instagram growth and content strategy for a creative design studio.",
  },
  {
    id: 16,
    title: "Vishwaksenaa Inst.",
    category: "social",
    link: "https://www.instagram.com/vishwaksenaa_institutions/",
    image: imgVishwaksenaa,
    tags: ["Social Media", "Education"],
    desc: "Social media management for an educational institution building brand awareness.",
  },
  {
    id: 17,
    title: "NTTS Mobility",
    category: "social",
    link: "https://www.instagram.com/nttsmobility/",
    image:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&h=600&fit=crop",
    tags: ["Social Media", "Fleet Management"],
    desc: "Instagram marketing for a mobility solutions brand with engaging content.",
  },
  {
    id: 18,
    title: "Tharun's Brainery",
    category: "social",
    link: "https://www.instagram.com/tharuns_brainery/",
    image: imgTharun,
    tags: ["Social Media", "Education"],
    desc: "Personal brand growth and content strategy for an education influencer.",
  },
  {
    id: 19,
    title: "BNI Luminaries",
    category: "social",
    link: "https://www.instagram.com/bni_luminaries_chennainorth/",
    image: imgBNI,
    tags: ["Social Media", "Networking"],
    desc: "Community management and content creation for a BNI networking chapter.",
  },
  // Graphic Designing
  {
    id: 20,
    title: "Graphic Design 1",
    category: "graphic",
    link: "#",
    image: gd1,
    tags: ["Graphic Design", "Branding"],
    desc: "Creative graphic design work showcasing brand identity and visual communication.",
  },
  {
    id: 21,
    title: "Graphic Design 2",
    category: "graphic",
    link: "#",
    image: gd2,
    tags: ["Graphic Design", "Print"],
    desc: "Professional print and digital design crafted for maximum visual impact.",
  },
  {
    id: 22,
    title: "Graphic Design 3",
    category: "graphic",
    link: "#",
    image: gd3,
    tags: ["Graphic Design", "Marketing"],
    desc: "Marketing collateral design with compelling visuals and brand consistency.",
  },
  {
    id: 23,
    title: "Graphic Design 4",
    category: "graphic",
    link: "#",
    image: gd4,
    tags: ["Graphic Design", "Social"],
    desc: "Social media creatives designed to boost engagement and brand awareness.",
  },
  {
    id: 24,
    title: "Graphic Design 7",
    category: "graphic",
    link: "#",
    image: gd7,
    tags: ["Graphic Design", "Creative"],
    desc: "Creative design solutions that communicate brand stories visually.",
  },
  {
    id: 25,
    title: "Graphic Design 11",
    category: "graphic",
    link: "#",
    image: gd11,
    tags: ["Graphic Design", "Visual"],
    desc: "Visual design work combining aesthetics and strategic brand messaging.",
  },
  // Logo Designing
  {
    id: 26,
    title: "Logo Designs",
    category: "logo",
    link: "#",
    image: imgLogosDesign,
    tags: ["Logo Design", "Branding"],
    desc: "Custom logo designs crafted to represent brand identity with clarity and creativity.",
  },
];

const filters = [
  { key: "all", label: "All Projects" },
  { key: "ecommerce", label: "E-commerce" },
  { key: "Business", label: "Business Websites" },
  { key: "landing", label: "Landing Pages" },
  // { key: 'software',  label: 'Software' },
  { key: "social", label: "Social Media" },
  { key: "graphic", label: "Graphic Designing" },
  { key: "logo", label: "Logo Designing" },
];

const designCards = [
  {
    icon: <BsPalette />,
    title: "Brochure Design",
    desc: "Professional brochures that tell your brand story",
  },
  {
    icon: <BsGrid />,
    title: "Flyer Design",
    desc: "Eye-catching flyers for events and promotions",
  },
  {
    icon: <BsPalette />,
    title: "Social Media Creatives",
    desc: "Engaging visuals for social platforms",
  },
];

const socialCards = [
  {
    icon: <BsInstagram />,
    title: "Instagram Marketing",
    desc: "Content strategy, reels, and community management for Instagram growth.",
  },
  {
    icon: <BsGrid />,
    title: "Content Creation",
    desc: "Eye-catching creatives, captions, and campaigns tailored to your brand.",
  },
  {
    icon: <BsPalette />,
    title: "Brand Awareness",
    desc: "Build a recognizable brand presence across all social platforms.",
  },
];

const stats = [
  { value: "300+", label: "Live Websites" },
  { value: "150+", label: "Happy Clients" },
  { value: "8+", label: "Technologies" },
  { value: "15+", label: "Industries" },
];

export const Projects = () => {
  const [active, setActive] = useState("all");
  const [lightbox, setLightbox] = useState(null); // holds image src

  const filtered =
    active === "all" ? projects : projects.filter((p) => p.category === active);

  return (
    <>
      {/* ── Hero ── */}
      <section className="pp-hero">
        <div className="pp-hero-orb" />
        <Container className="position-relative z-1 text-center">
          <div className="hero-badge-wrap mb-4">
            <span className="hero-badge">
              <Badge className="badge-new">Work</Badge>
              That Speaks
            </span>
          </div>
          <h1 className="pp-hero-title">Our Portfolio</h1>
          <p className="pp-hero-sub">
            Explore a collection of projects where strategy, creativity, and
            execution come together to build strong digital presence and drive
            business growth.
          </p>
          <div className="hero-actions mt-4">
            <Link to="/contact" className="btn-get-in-touch-hero">
              Get Started <span className="arrow-icon">↗</span>
            </Link>
            <Link to="/Contact" className="btn-view-services">
              Contact Us
            </Link>
          </div>
        </Container>
      </section>

      {/* ── SEO Intro ── */}
      {/* <section className="pp-seo">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <p className="pp-seo-text">
                From <strong>e-commerce stores and SaaS platforms</strong> to{' '}
                <strong>mobile apps, landing pages, and enterprise software</strong> — our
                portfolio spans 15+ industries. Every project is built with performance,
                SEO, and conversion in mind.
              </p>
            </Col>
          </Row>
        </Container>
      </section> */}

      {/* ── Social Media Projects ── */}
      {/* <section className="pp-design-section">
        <Container>
          <div className="text-center mb-4">
            <h2 className="pp-section-title"><BsInstagram className="pp-section-icon" /> Social Media Marketing</h2>
            <p className="pp-section-sub">Instagram growth, content strategy, and community management for brands across industries</p>
          </div>
          <Row className="g-4 justify-content-center mb-4">
            {socialCards.map((c, i) => (
              <Col key={i} xs={12} md={4}>
                <div className="pp-design-card">
                  <div className="pp-design-icon">{c.icon}</div>
                  <p className="pp-design-title">{c.title}</p>
                  <p className="pp-design-desc">{c.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}

      {/* ── Development Projects ── */}
      <section className="pp-dev-section">
        <Container>
          {/* <div className="text-center mb-4">
            <h2 className="pp-section-title"><BsCodeSlash className="pp-section-icon" /> Development Projects</h2>
            <p className="pp-section-sub">300+ live websites built across various technologies for clients worldwide</p>
          </div> */}

          {/* NDA note */}
          {/* <div className="pp-nda-note">
            <strong>Note:</strong> Please schedule a call to discuss these confidential projects.
          </div> */}

          {/* Stats */}
          {/* <Row className="g-3 mb-5">
            {stats.map((s, i) => (
              <Col key={i} xs={6} md={3}>
                <div className="pp-stat-card">
                  <p className="pp-stat-value">{s.value}</p>
                  <p className="pp-stat-label">{s.label}</p>
                </div>
              </Col>
            ))}
          </Row> */}

          {/* Filter tabs */}
          <div className="pp-filters">
            {filters.map((f) => (
              <button
                key={f.key}
                className={`pp-filter-btn ${active === f.key ? "active" : ""}`}
                onClick={() => setActive(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Project cards */}
          <Row className="g-4 gy-5 mt-2">
            {filtered.map((p) => (
              <Col key={p.id} xs={12} sm={6} lg={4}>
                <article className="pp-card">
                  <div
                    className="pp-card-img-wrap"
                    onClick={() =>
                      (p.category === "graphic" || p.category === "logo") && setLightbox(p.image)
                    }
                    style={{
                      cursor: (p.category === "graphic" || p.category === "logo") ? "pointer" : "default",
                    }}
                  >
                    <img
                      src={p.image}
                      alt={p.title}
                      className="pp-card-img"
                      loading="lazy"
                    />
                    {p.category !== "graphic" && p.category !== "logo" && (
                      <>
                        <span className="pp-card-category">{p.tags[0]}</span>
                        <a
                          href={p.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="pp-visit-btn"
                        >
                          <BsBoxArrowUpRight /> Visit Site
                        </a>
                      </>
                    )}
                  </div>
                  {p.category !== "graphic" && p.category !== "logo" && (
                    <div className="pp-card-body">
                      <h3 className="pp-card-title">{p.title}</h3>
                      {/* <p className="pp-card-desc">{p.desc}</p> */}
                      <div className="pp-card-tags mt-2">
                        {p.tags.map((t, i) => (
                          <span key={i} className="pp-card-tag">
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </article>
              </Col>
            ))}
          </Row>

          {/* View more on Drive — only for Graphic Designing */}
          {(active === "graphic" || active === "logo") && (
            <div className="text-center mt-4">
              <a
                href="https://drive.google.com/drive/folders/16dgHv5iZ2CvvroPu_9ScbBSc3Up0_0OL?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="pp-drive-more-btn"
              >
                <BsBoxArrowUpRight /> View More on Google Drive
              </a>
            </div>
          )}
        </Container>
      </section>

      {/* ── CTA ── */}
      <section className="pp-cta">
        <div className="pp-cta-orb" />
        <Container className="position-relative z-1 text-center">
          <h2 className="pp-cta-title">Ready to Turn Ideas into Results?</h2>
          <p className="pp-cta-sub">
            Let’s discuss your goals and create a solution designed to attract, engage, and convert your audience.
          </p>
          <div className="pp-cta-btns">
            <Link to="/contact" className="pp-cta-primary">
              Get Started
            </Link>
            <Link to="/Contact" className="pp-cta-secondary">
              Contact Us
            </Link>
          </div>
        </Container>
      </section>

      {/* Lightbox Modal */}
      <Modal
        show={!!lightbox}
        onHide={() => setLightbox(null)}
        centered
        size="xl"
        className="pp-lightbox-modal"
      >
        <Modal.Body className="p-0 position-relative">
          <button
            className="pp-lightbox-close"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <BsX />
          </button>
          {lightbox && (
            <img
              src={lightbox}
              alt="Design Preview"
              className="pp-lightbox-img"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
